import React, { useState, useRef, useEffect } from "react";
import {BsClock, BsEnvelope, BsFillPencilFill,BsTrash,BsPlay, BsInfo,BsKey,BsArrowRepeat, BsAsterisk, BsBuilding, BsPlus, BsShieldPlus , BsShieldMinus  } from 'react-icons/bs';
import { useConfirm } from '../components/ConfirmContext';
import { differenceInDays, parseISO } from "date-fns"; // date-fns ułatwia operacje na datach

export default function CostActions({logedUser,addPayCostFV, RunCost,details, row,onDelete, onSendLicense, onEdit,onSendOneMoreTime, onRefresh, renvewSubscription, disableSubscription, onSendEmail, editParserAccess, editAditionalModules, onAcceptPrzetwarzanie }) {
  const { requestConfirm } = useConfirm();

  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ x: 0, y: 0 });
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
function SubscriptionButton({ row, disableSubscription, setOpen }) {
  const expireDate = parseISO(row.shop_expireDate); // zakładam, że shop_expireDate jest w formacie ISO
  const daysLeft = differenceInDays(expireDate, new Date());

  const canDisable = daysLeft >= 7;

  return (
    <button
      onClick={
        canDisable
          ? () => {
              requestConfirm(
                `Czy na pewno chcesz wyłączyć subskrypcję użytkownikowi?`,
                () => {
                  disableSubscription(row);
                  setOpen(false);
                }
              );
            }
          : undefined
      }
      className={`flex items-center gap-2 w-full px-3 py-2 ${
        canDisable
          ? "text-primary-500 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
          : "text-gray-400 cursor-not-allowed"
      }`}
    >
      <BsShieldMinus className="w-4 h-4" />
      <span>{canDisable ? "Wyłącz subskrypcję" : "Nie można wyłączyć subskrypcji"}</span>
    </button>
  );
}

  // 🔒 Zamknij po kliknięciu poza (ale nie w menu)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !buttonRef.current?.contains(e.target) &&
        !menuRef.current?.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 📍 Pozycjonowanie menu
  const handleToggleMenu = () => {
    if (!open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({ x: rect.right - 180, y: rect.top }); // 180 = szerokość menu
    }
    setOpen((prev) => !prev);
  };
const menuHeight = 200; // albo zmierz refem
const shouldOpenUp =
  menuPos.y + menuHeight > window.innerHeight;
  return (
    <>
      {/* Przycisk trzech kropek */}
      <button
        ref={buttonRef}
        onClick={handleToggleMenu}
        className="p-2 rounded hover:bg-gray-100 transition"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 text-gray-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 12h.01M12 12h.01M18 12h.01" />
        </svg>
      </button>

      {/* FIXED menu – nie rozszerza tabeli */}
      {open && (
        <div
        ref={menuRef}
          style={{
    position: "fixed",
    left: `${menuPos.x}px`,
    top: shouldOpenUp ? "auto" : `${menuPos.y}px`,
    bottom: shouldOpenUp
      ? `${window.innerHeight - menuPos.y}px`
      : "auto",
    zIndex: 9999,
  }}
          className="
            bg-white border border-gray-200 rounded-sm shadow-sm
            animate-fadeIn
          "
        >
       <ul className="py-1 text-gray-700">
          
          
           {row.status !== "1" ? (
           <li>
        <button
          onClick={() => {
            details(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsInfo className="w-4 h-4" />
          <span>Szczegóły</span>
        </button>
      </li>
           ):(
             <li>
        <button

        onClick={() => {
              requestConfirm(
                `Czy na pewno chcesz aktywować koszt do rozliczenia?`,
                () => {
                  RunCost(row);
                  setOpen(false);
                }
              );
            }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsPlay className="w-4 h-4" />
          <span>Uruchom rozliczenie</span>
        </button>
      </li>
           )}
 {row.status !== "1" ? (
   <li>
        <button
          onClick={() => {
            addPayCostFV(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsPlus className="w-4 h-4" />
          <span>Dodaj spłatę</span>
        </button>
      </li>):('')}

  {row.status !== "1" ? (
   <li>
        <button
          onClick={() => {
            onEdit(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsArrowRepeat className="w-4 h-4" />
          <span>Zmień status</span>
        </button>
      </li>):('')}

      <li>
        <button
          onClick={() => {
            onEdit(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsFillPencilFill className="w-4 h-4" />
          <span>Edytuj</span>
        </button>
      </li>
        {row.status === "1" ? (
      <li>
        <button
            onClick={() => {
              requestConfirm(
                `Czy na pewno chcesz usunąć koszt z systemu?`,
                () => {
                onDelete(row);
                setOpen(false);
                }
              );
            }}
          className="flex items-center text-primary-500 gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsTrash className="w-4 h-4" />
          <span>Usuń</span>
        </button>
      </li>
        ):('')}
 
</ul>

        </div>
      )}
    </>
  );
}
